/**
 * Business Unit Context Definition
 * 
 * Contains ONLY the context creation and type definitions.
 * NO hooks, NO providers - just the context itself.
 */

import { createContext } from 'react';
import { WorkspaceScope } from '@/lib/workspaceScope';

export interface BusinessUnit {
  id: string;
  name: string;
  workspace_id: string;
  created_at: string;
}

export interface BusinessUnitContextValue {
  businessUnits: BusinessUnit[];
  activeBusinessUnitId: string | null; // null = "All"
  setActiveBusinessUnitId: (businessUnitId: string | null) => void;
  isLoading: boolean;
  error: { message: string; code?: string } | null;
  refetchBusinessUnits: () => void;
  scope: WorkspaceScope;
  accessibleWorkspaceIds: string[];
}

// Export context for direct useContext access
export const BusinessUnitContext = createContext<BusinessUnitContextValue | undefined>(undefined);

